// Translation: German > Terminology
const terminology = Object.freeze({
	agent: '',
	agent_one: '',
	agent_other: '',
	agentStatusItems: {
		deleted: '',
		draft: '',
		onboarded: ''
	},
	agents: '',
	agentWithCount_one: '',
	agentWithCount_other: '',
	agentWithId: '',
	asset: '',
	asset_one: '',
	asset_other: '',
	assets: '',
	assetWithCount_one: '',
	assetWithCount_other: '',
	assetWithVersion: '',
	automode: '',
	benchmark: '',
	benchmark_one: '',
	benchmark_other: '',
	benchmarks: '',
	benchmarkStatusItems: {
		calculate_scores: '',
		completed: '',
		failed: '',
		in_progress: ''
	},
	benchmarkWithCount_one: '',
	benchmarkWithCount_other: '',
	benchmarkWithId: '',
	categories: '',
	category: '',
	category_one: '',
	category_other: '',
	categoryWithCount_one: '',
	categoryWithCount_other: '',
	character: '',
	character_one: '',
	character_other: '',
	characters: '',
	characterWithCount_one: '',
	characterWithCount_other: '',
	column: '',
	column_one: '',
	column_other: '',
	columns: '',
	columnWithCount_one: '',
	columnWithCount_other: '',
	corpora: '',
	corpus: '',
	corpus_one: '',
	corpus_other: '',
	corpusPrivacyTypeItems: {
		Private: '',
		Public: ''
	},
	corpusStatusItems: {
		deleted: '',
		failed: '',
		onboarded: '',
		onboarding: ''
	},
	corpusWithCount_one: '',
	corpusWithCount_other: '',
	corpusWithId: '',
	credit: '',
	credit_one: '',
	credit_other: '',
	creditAsRange: '',
	credits: '',
	creditWithCount_one: '',
	creditWithCount_other: '',
	data: '',
	dataset: '',
	dataset_one: '',
	dataset_other: '',
	datasetMetadataTypeItems: {
		age: '',
		gender: '',
		other: '',
		race: '',
		split: '',
		topic: ''
	},
	datasets: '',
	datasetStatusItems: {
		deleted: '',
		failed: '',
		onboarded: '',
		onboarding: ''
	},
	datasetUsageTypeItems: {
		development: '',
		developmentInShort: '',
		training: '',
		trainingInShort: ''
	},
	datasetWithCount_one: '',
	datasetWithCount_other: '',
	datasetWithFunction: '',
	datasetWithId: '',
	dataSubTypeItems: {
		boolean: '',
		file: '',
		json: '',
		labeledImage: '',
		labeledText: '',
		number: ''
	},
	dataTypeItems: {
		audio: '',
		image: '',
		label: '',
		number: '',
		text: '',
		video: ''
	},
	decisionInputItems: {
		comparison: '',
		passthrough: ''
	},
	draft: '',
	file: '',
	file_one: '',
	file_other: '',
	files: '',
	fileStatusItems: {
		canceled: '',
		canceling: '',
		completed: '',
		failed: '',
		in_progress: '',
		pending: ''
	},
	fileWithCount_one: '',
	fileWithCount_other: '',
	fileWithId: '',
	finetune: '',
	function: '',
	function_one: '',
	function_other: '',
	functionInputItems: {
		action: '',
		apl_qfactor: '',
		audio: '',
		chunk_max_seconds: '',
		context: '',
		data: '',
		dialect: '',
		dialect_in: '',
		dialect_out: '',
		domain: '',
		enable_denormalizer: '',
		featuretypes: '',
		format: '',
		frequency_penalty: '',
		gender: '',
		history: '',
		image: '',
		inputtext: '',
		is_medical: '',
		language: '',
		lowercase_latin: '',
		max_duration_seconds: '',
		max_new_tokens: '',
		max_tokens: '',
		max_tokens_to_sample: '',
		min_confidence: '',
		min_duration_off: '',
		min_duration_on: '',
		modelid: '',
		next_state: '',
		normalize_arabic: '',
		num_return_sequences: '',
		numResults: '',
		offset: '',
		onset: '',
		option_index: '',
		output: '',
		payload: '',
		pitch: '',
		presence_penalty: '',
		prompt: '',
		query: '',
		remove_accents: '',
		remove_arabic_diacritics: '',
		remove_arabic_superfluous: '',
		remove_punctuation: '',
		result_format: '',
		script: '',
		script_in: '',
		script_out: '',
		seed: '',
		session_id: '',
		settings: '',
		similarity_boost: '',
		source_audio: '',
		source_supplier: '',
		sourcelanguage: '',
		speed: '',
		stability: '',
		style: '',
		supplier_model_id: '',
		tags: '',
		target_supplier: '',
		targetimage: '',
		targetlanguage: '',
		targetlanguages: '',
		temperature: '',
		template: '',
		text: '',
		top_k: '',
		top_p: '',
		transcript: '',
		type: '',
		url: '',
		video: '',
		voice: '',
		voice_id: ''
	},
	functionItems: {
		'activity-detection': '',
		'asr-age-classification': '',
		'asr-gender-classification': '',
		'asr-quality-estimation': '',
		'audio-forced-alignment': '',
		'audio-generation-metric': '',
		'audio-reconstruction': '',
		'audio-source-separation': '',
		'audio-transcript-analysis': '',
		'audio-transcript-improvement': '',
		'auto-mask-generation': '',
		'benchmark-scoring-asr': '',
		'benchmark-scoring-mt': '',
		'classification-metric': '',
		default: '',
		'detect-language-from-text': '',
		diacritization: '',
		'dialect-detection': '',
		'emotion-detection': '',
		'entity-linking': '',
		'entity-sentiment-analysis': '',
		'expression-detection': '',
		'extract-audio-from-video': '',
		'facial-recognition': '',
		'fill-text-mask': '',
		'image-analysis': '',
		'image-and-video-analysis': '',
		'image-captioning': '',
		'image-compression': '',
		'image-content-moderation': '',
		'image-label-detection': '',
		'image-manipulation': '',
		'intent-recognition': '',
		'keyword-extraction': '',
		'language-identification': '',
		'language-identification-audio': '',
		loglikelihood: '',
		'metric-aggregation': '',
		'named-entity-recognition': '',
		'object-detection': '',
		ocr: 'OCR',
		'offensive-language-identification': '',
		paraphrasing: '',
		'question-answering': '',
		'referenceless-audio-generation-metric': '',
		'referenceless-text-generation-metric': '',
		'referenceless-text-generation-metric-default': '',
		'scene-detection': '',
		'script-execution': '',
		search: '',
		'sentiment-analysis': '',
		'speaker-diarization-audio': '',
		'speaker-diarization-video': '',
		'speaker-recognition': '',
		'speech-classification': '',
		'speech-embedding': '',
		'speech-non-speech-classification': '',
		'speech-recognition': '',
		'speech-synthesis': '',
		'speech-translation': '',
		'split-on-linebreak': '',
		'split-on-silence': '',
		subtitling: '',
		'subtitling-translation': '',
		summarization: '',
		'syntax-analysis': '',
		'table-question-answering': '',
		'text-classification': '',
		'text-content-moderation': '',
		'text-denormalization': '',
		'text-detection': '',
		'text-embedding': '',
		'text-generation': '',
		'text-generation-metric': '',
		'text-generation-metric-aggregation': '',
		'text-generation-metric-default': '',
		'text-normalization': '',
		'text-reconstruction': '',
		'text-segmentation': '',
		'text-spam-detection': '',
		'text-summarization': '',
		'text-to-image-generation': '',
		'text-transformation': '',
		tools: '',
		'topic-classification': '',
		'topic-modeling': '',
		translation: '',
		utilities: '',
		'video-content-moderation': '',
		'video-forced-alignment': '',
		'video-generation': '',
		'video-label-detection': '',
		'video-understanding': '',
		'viseme-generation': '',
		'voice-activity-detection': '',
		'voice-cloning': '',
		'zero-shot-classification': ''
	},
	functionOutputItems: {
		audio: '',
		confidence: '',
		data: '',
		image: '',
		input: '',
		label: '',
		score: '',
		text: '',
		video: ''
	},
	functions: '',
	functionWithCount_one: '',
	functionWithCount_other: '',
	hypotheses: '',
	hypothesis: '',
	hypothesis_one: '',
	hypothesis_other: '',
	input: '',
	input_one: '',
	input_other: '',
	inputLanguage: '',
	inputLanguage_one: '',
	inputLanguage_other: '',
	inputLanguages: '',
	inputLanguageWithCount_one: '',
	inputLanguageWithCount_other: '',
	inputs: '',
	inputWithCount_one: '',
	inputWithCount_other: '',
	label: '',
	label_one: '',
	label_other: '',
	labels: '',
	labelWithCount_one: '',
	labelWithCount_other: '',
	language: '',
	language_one: '',
	language_other: '',
	languages: '',
	languageWithCount_one: '',
	languageWithCount_other: '',
	license: '',
	metadata: '',
	metric: '',
	metric_one: '',
	metric_other: '',
	metricInputItems: {
		hypotheses: '',
		references: '',
		score_identifier: '',
		sources: ''
	},
	metrics: '',
	metricStatusItems: {
		deleted: '',
		deleting: '',
		disabled: '',
		enabling: '',
		failed: '',
		hidden: '',
		onboarded: '',
		onboarding: '',
		training: ''
	},
	metricWithCount_one: '',
	metricWithCount_other: '',
	metricWithId: '',
	model: '',
	model_one: '',
	model_other: '',
	modelNodeInstanceTypeItems: {
		ai: '',
		reconstructor: '',
		segmentor: '',
		utility: ''
	},
	models: '',
	modelStatusItems: {
		deleted: '',
		deleting: '',
		disabled: '',
		enabling: '',
		failed: '',
		hidden: '',
		onboarded: '',
		onboarding: '',
		training: ''
	},
	modelWithCount_one: '',
	modelWithCount_other: '',
	modelWithId: '',
	nodeTypeItems: {
		decision: '',
		function: '',
		input: '',
		metric: '',
		model: '',
		output: '',
		router: '',
		script: ''
	},
	normalization: '',
	normalization_one: '',
	normalization_other: '',
	normalizationItems: {
		default: '',
		'denormalize spoken text': '',
		'lowercase text': '',
		'normalize default arabic': '',
		'normalize full arabic': '',
		'normalize quotes': '',
		'normalize spoken text': '',
		'remove arabic superfluous': '',
		'remove default arabic diacritics': '',
		'remove emails': '',
		'remove emojis': '',
		'remove full arabic diacritics': '',
		'remove html tags': '',
		'remove kashida dagger': '',
		'remove phone numbers': '',
		'remove punctuations': '',
		'remove urls': '',
		'tokenize text': ''
	},
	normalizations: '',
	output: '',
	output_one: '',
	output_other: '',
	outputLanguage: '',
	outputLanguage_one: '',
	outputLanguage_other: '',
	outputLanguages: '',
	outputLanguageWithCount_one: '',
	outputLanguageWithCount_other: '',
	outputs: '',
	outputWithCount_one: '',
	outputWithCount_other: '',
	owner: '',
	owner_one: '',
	owner_other: '',
	owners: '',
	ownerWithCount_one: '',
	ownerWithCount_other: '',
	pipeline: '',
	pipeline_one: '',
	pipeline_other: '',
	pipelineDraft: '',
	pipelineDraft_one: '',
	pipelineDraft_other: '',
	pipelineDrafts: '',
	pipelineDraftWithCount_one: '',
	pipelineDraftWithCount_other: '',
	pipelineDraftWithId: '',
	pipelines: '',
	pipelineTemplate: '',
	pipelineTemplate_one: '',
	pipelineTemplate_other: '',
	pipelineTemplates: '',
	pipelineTemplateWithCount_one: '',
	pipelineTemplateWithCount_other: '',
	pipelineTemplateWithId: '',
	pipelineWithCount_one: '',
	pipelineWithCount_other: '',
	pipelineWithId: '',
	pricingTypeItems: {
		free: '',
		oneTime: '',
		perUse: ''
	},
	privacy: '',
	privacyTypeItems: {
		private: '',
		public: '',
		restricted: ''
	},
	reference: '',
	referenceless: '',
	report: '',
	report_one: '',
	report_other: '',
	reports: '',
	reportWithCount_one: '',
	reportWithCount_other: '',
	reportWithId: '',
	request: '',
	request_one: '',
	request_other: '',
	requests: '',
	requestWithCount_one: '',
	requestWithCount_other: '',
	resource: '',
	resource_one: '',
	resource_other: '',
	resources: '',
	resourceWithCount_one: '',
	resourceWithCount_other: '',
	score: '',
	score_one: '',
	score_other: '',
	scores: '',
	segment: '',
	segment_one: '',
	segment_other: '',
	segmentCount: '',
	segments: '',
	segmentWithCount_one: '',
	segmentWithCount_other: '',
	segmentWithIndex: '',
	source: '',
	status: '',
	subcategories: '',
	subcategory: '',
	subcategory_one: '',
	subcategory_other: '',
	subcategoryWithCount_one: '',
	subcategoryWithCount_other: '',
	submetric: '',
	submetric_one: '',
	submetric_other: '',
	submetrics: '',
	submetricWithCount_one: '',
	submetricWithCount_other: '',
	supplier: '',
	template: '',
	token: '',
	token_one: '',
	token_other: '',
	tokens: '',
	tokenWithCount_one: '',
	tokenWithCount_other: '',
	user: '',
	user_one: '',
	user_other: '',
	users: '',
	userWithCount_one: '',
	userWithCount_other: '',
	utilities: '',
	utility: '',
	utility_one: '',
	utility_other: '',
	utilityStatusItems: {
		deleted: '',
		deleting: '',
		disabled: '',
		enabling: '',
		failed: '',
		hidden: '',
		onboarded: '',
		onboarding: '',
		training: ''
	},
	utilityWithCount_one: '',
	utilityWithCount_other: '',
	utilityWithId: '',
	vendor: '',
	vendor_one: '',
	vendor_other: '',
	vendors: '',
	vendorWithCount_one: '',
	vendorWithCount_other: '',
	version: '',
	version_one: '',
	version_other: '',
	versions: '',
	versionWithCount_one: '',
	versionWithCount_other: ''
})

// Export
export default terminology
